const fr = {
    resources: {
        documentation: "Documentation",
        alreadyTranslate: "%{message}",
        file: {
            success: "Fichier supprimé avec succès",
            remove: "Impossible de supprimer le fichier (%{err})"
        },
        enabled: {
            generic: "Le formulaire n'est pas valide",
            wrongReturnType: "Le type de retour pour la validation n'est pas correct"
        },
        disabled: {
            generic: "Le formulaire ne peut pas être désactivé",
            wrongReturnType: "Le type de retour pour la déactivation n'est pas correct"
        },
        validate: {
            coherenceDate: "La date de début doit être inférieur ou égale à la date de fin",
            requiredFieldFor: "\"%{field}\" est requis %{for}",
            unitTime: "Veuillez saisir votre temps passé"
        },
        login: {
            back: "Serveur d'authentification inaccessible"
        },
        settings: "Paramètres",
        forceGo: "Forcer terminer",
        forceBack: "Forcer annuler",
        bulkAssignMyself: "Assigner à soi-même",
        editTitle: "Édition",
        loading: "Chargement...",
        add: "Ajouter",
        remove: "Enlever",
        cancel: "Annuler",
        close: "Fermer",
        start: "Démarrer",
        assign: "Assigner",
        unassign: "Désaffecter",
        valid: "Valider",
        reject: "Rejeter",
        activate: "Vérifier et activer",
        deactivate: "Désactiver",
        details: "Détails",
        undefined: {
            name: '??? |||| ???',
        },
        role: {
            admin: "Administrateur",
            projectManager: "Responsable de projet",
            teamManager: "Responsable d'équipe",
            productor: "Producteur"
        },
        unitTime: {
            hour: "Heure(s)",
            minute: "Minute(s)"
        },
        unitTimeTranslate: {
            hour: "%{value} heure |||| %{value} heures",
            minute: "%{value} minute |||| %{value} minutes"
        },
        tracking: {
            waiting: "En attente",
            inProgress: "En cours",
            completed: "Terminé"
        },
        status: {
            draft: "Brouillon",
            enabled: "Actif",
            disabled: "Inactif"
        },
        taskStatus: {
            waiting: "En attente",
            available: "Disponible",
            assigned: "Assigné",
            completed: "Terminé",
            rejected: "Rejeté",
            cancelled: "Annulé"
        },
        common: {
            actionTitle: {
                deactivate: "Déactivation %{resourceName}"
            },
            actionContent: {
                deactivate: "Voulez-vous vraiment effectuer une désactivation %{resourceName} ? Cette action est irréversible et permettra de cacher, par défaut, cette resource sur tous les écrans, néanmoins la dupplication restera possible."
            },
        },
        workflow: {
            name: "du flux opérationnel |||| Flux opérationnels",
            errors: {
                endShouldBeConnectedToStart: "Le début doit être connecté à la fin dans un flux sans erreur en passant par au moins une étape",
                atLeastOne: "Un flux opérationnel doit avoir au minimum une étape",
                stageWithoutIn: "L'étape \"%{name}\" n'a pas de connexion entrante",
                stageNeedOutgoing: "L'étape \"%{name}\" n'a pas de connexion sortante sans erreur",
                stageReferenceItselfIncoming: "L'étape \"%{name}\" à une référence circulaire sur lui-même (le flux sans erreur ne doit pas faire de boucle)",
                stageShouldBeConnectToStart: "L'étape \"%{name}\" n'est pas connecté à l'étape de début (via un parent ou lui-même)"
            },
            fields: {
                id: "Identifiant",
                name: "Nom",
                description: "Description",
                model: "Modèle",
                status: "Statut",
                ownerId: "Créateur"
            }
        },
        geometry: {
            import: "Importer les géométries",
            importTitle: "Veuillez mettre un fichier CSV content un champs geometry et un ou des attributs permettant d'identifier l'unité de production.\nSoit 'id' ou 'name' + 'lotId' ou 'name' + 'lotName'.\n'id' correspondant à l'identifiant de l'unité de production et le 'name' au nom de l'unité de production. La geometrie doit être avec une projection EPSG:3857",
            filled: "Possède une géométrie",
            failed: "La géometrie n'est pas un geojson conforme",
            empty: "Ne possède pas de géométrie",
            summary: {
                added: "1 géométrie mise à jour |||| %{smart_count} géométries mises à jour",
                notJSON: "Dont 1 geométrie n'est pas au format geojson |||| Dont %{smart_count} geométries ne sont pas au format geojson",
                noGeometry: "1 ligne ne contient pas d'attribut \"geometry\" |||| %{smart_count} lignes ne contiennent pas d'attribut \"geometry\"",
                noRelatedAttribute: "1 ligne ne contient pas d'attribut permettant d'identifier l'unité de production |||| %{smart_count} lignes ne contiennent pas d'attribut permettant d'identifier l'unité de production",
                notFound: "1 ligne ne correspond pas à une unité de production de votre projet |||| %{smart_count} lignes ne correspondent pas à des unités de production de votre projet",
                nothing: "Le fichier ne contient aucune donnée à importer"
            }
        },
        project: {
            name: "du projet |||| Projets",
            showGrid: "Afficher en grille de données",
            showSchema: "Afficher en schéma",
            errors: {
                for: "pour l'étape \"%{name}\""
            },
            map: {
                name: "Carte",
                title: "Carte du projet"
            },
            stats: {
                name: "Statistiques",
                title: "Statistiques projet"
            },
            stages: {
                name: "Assignation des étapes",
                legend: "Veuillez cliquer sur l'étape que vous souhaitez assigner",
                quantity: "L'équipe doit produire",
                duration: "Dans un délai de"
            },
            lot: {
                name: "Affectation des lots"
            },
            delegate: {
                name: "Délégation"
            },
            fields: {
                id: "Identifiant",
                name: "Nom",
                status: "Statut",
                description: "Description",
                workflowId: "Flux opérationnel",
                unitProd: "Nom de l'unités d'œuvre",
                unitMeasure: "Nom de l'unité de mesure",
                atheneo: "Numéro ATHENEO",
                hasCustomDashboard: "Dispose d'un tableau de bord personnalisé?",
                hasExternalProductionFile: "Dispose d'un système de fichiers de production externe ?",
                hasExternalProductionFileHelper: "Par défaut, le système vous permet de déposer de petits fichiers de production mais vous pouvez utiliser un système de fichier externe. Ensuite, lorsqu'une tâche est créée, vous pouvez joindre un lien vers votre propre système de fichiers (ex:\"sharepoint\"...)",
                hasMap: "Dispose d'une carte?",
                customDashboardId: "Identifiant du tableau de bord personnalisé",
                ownerId: "Créateur"
            }
        },
        stage_infos: {
            name: "Informations de l'étape",
            fields: {
                quantity: "Quantité",
                duration: "Durée",
                unitTime: "Unité de temps",
                stageId: "Nom de l'étape",
                assignId: "Equipe en charge de l'étape",
                isMultipleTeam: "Est-ce qu'il y a plusieurs équipes ?",
                isSubproject: "Est-ce un sous projet?",
                subprojectId: "Sous projet"
            }
        },
        team: {
            name: "de l'équipe |||| Equipes",
            member: "Producteur",
            fields: {
                id: "Identifiant",
                name: "Nom",
                description: "Description",
                managerId: "Responsable",
                members: "Producteurs"
            }
        },
        project_delegate: {
            mydelegate: "Mes responsables de projets délégués",
            others: "Autres responsable de projet disponible",
            add: "Responsable de projet ajouté au projet",
            remove: "Responsable de projet enlevé du projet"
        },
        userTeam: {
            myteam: "Mon équipe",
            others: "Autres producteurs disponible",
            add: "Utilisateur ajouté à l'équipe",
            remove: "Utilisateur enlevé de l'équipe"
        },
        user: {
            name: "de l'utilisateur |||| Utilisateurs",
            identity: "Identité",
            fields: {
                id: "Identifiant",
                firstname: "Prénom",
                lastname: "Nom",
                fullname: "Nom complet",
                email: "Email",
                role: "Rôle"
            }
        },
        lot: {
            name: "un lot de production |||| Lots de production",
            validate: {
                projectEnabled: "Le projet associé doit être actif",
                empty: "Le lot est vide, veuillez ajouter des unités de productions"
            },
            fields: {
                id: "Identifiant",
                name: "Nom",
                startDate: "Date de début",
                endDate: "Date de fin",
                projectId: "Projet",
                tracking: "Statut"
            }
        },
        production_unit: {
            name: "de l'unité d'œuvre |||| Unités d'œuvre",
            fields: {
                id: "Identifiant",
                name: "Nom",
                stageName: "Etape",
                quantity: "Quantité",
                quantityReal: "Quantité réelle",
                comment: "Commentaires",
                lotId: "Lot de production",
                numberProductionUnits: "Nombre d'unités d'œuvre",
                automaticIncrementName: "Noms incrémentés automatiquement",
                tracking: "Statut"
            }
        },
        task: {
            name: "de la tâche |||| Tâches",
            validate: {
                needComment: "Pour rejeter une tâche, il faut renseigner un commentaire.",
                needNextTeam: "Pour valider cette tâche, il faut renseigner l'équipe en charge de la prochaine étape",
                needRejectTeam: "Pour rejeter cette tâche, il faut renseigner l'équipe en charge du rejet"

            },
            actionTitle: {
                cancel: "Annuler la tâche",
                bulkAssignMyself: "Assigner la sélection à soi-même",
                bulkUnassign: "Désassigner la sélection",
                forceGo: "Forcer la fin des tâches sélectionnées",
                forceBack: "Forcer la réactivation des tâches sélectionnées"
            },
            actionContent: {
                cancel: "Voulez-vous vraiment annuler cette tâche ? Cela n'est pas le processus normal du flux opérationnel, cela recréera les éventuelles tâches précédentes.",
                bulkAssignMyself: "Voulez-vous vraiment vous affecter les tâches sélectionnées?",
                bulkUnassign: "Voulez-vous vraiment désaffecter les tâches sélectionnées?",
                forceGo: "Voulez-vous vraiment forcer la fin des tâches sélectionnées ? A noter que cela ne permet pas de saisir le temps ainsi que les commentaires et ne crée pas les tâches pour les sous-projets.",
                forceBack: "Voulez-vous vraiment forcer l'annulation des tâches sélectionnées? Les unités d'oeuvres rattachées redeviendront en cours ainsi que les tâches sélectionnées.",
            },
            success: {
                cancel: "La tâche a été annulé et ses étapes précédentes ont été recréées",
                bulkAssignMyself: "La tâche a été assignée |||| Les tâches ont été assignées",
                bulkUnassign: "La tâche a été désassignée |||| Les tâches ont été désassignées",
                forceGo: "La tâche a été terminée |||| Les tâches ont été terminées",
                forceBack: "La tâche a été réactivé |||| Les tâches ont été réactivées"
            },
            error: {
                bulkAssignMyselfSubproject: "Cette tâche a un sous-projet, elle ne peut donc pas être assigné |||| Au moins une tâche a un sous-projet qui ne peut donc pas être assigné en masse",
            },
            fields: {
                sub: "Découpage dans le sous projet",
                team: "Equipe",
                project: "Projet",
                lot: "Lot de production",
                "stage.name": "Etape",
                productionUnitId: "Unité d'œuvre",
                "production_unit.lot.endDate": "Date fin du lot",
                estimateTime: "Temps estimé",
                inputTime: "Temps réalisé",
                taskStatus: "Statut",
                quantity: "Quantité",
                quantityTask: "Quantité observée",
                "production_unit.lot.name": "Nom du lot",
                assignTo: "Assigné",
                comment: "Commentaires",
                commentTask: "Ajouter un commentaire",
                endDate: "Date de fin",
                assignedDate: "Date d'assignation",
                availableDate: "Date de disponibilité",
                previousProductionFileExternal: "Fichier de production précédent",
                previousProductionFile: "Fichier de production précédent",
                previousShuttleFile: "Fichier navette précédent",
                productionFile: "Fichier de production",
                productionFileExternal: "Fichier de production",
                shuttleFile: "Fichier navette",
                nextTeamAssignTo: "Equipe assignée à la prochaine tâche",
                rejectTeamAssignTo: "Equipe assignée à la tâche de rejet"
            }
        }
    }
};
export default fr;